//* warehouses id
export const ESTUDIONUBE = 1695;
export const ESTRADA = 1;
export const TOM = 1974;

//* map coordinates
export const DEFAULT_BA_COORDINATES = [-34.6160074, -58.5033385];

export const HOURS_LIST = [
  "00:00",
  "01:00",
  "02:00",
  "03:00",
  "04:00",
  "05:00",
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
  "22:00",
  "23:00",
  "23:59",
];
